var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.595 10.5432L10.638 16.5299C10.3282 16.8315 9.921 17 9.49613 17H7.41602C7.30095 17 7.19473 16.9557 7.11507 16.8758C7.03541 16.796 7 16.6896 7 16.5743L7.05311 14.4723C7.06196 14.0554 7.23014 13.6652 7.52224 13.3725L11.7444 9.14191C11.8152 9.07095 11.9391 9.07095 12.01 9.14191L13.4908 10.6169C13.5882 10.7135 13.7298 10.7765 13.8803 10.7765C14.2078 10.7765 14.4645 10.5104 14.4645 10.1911C14.4645 10.0315 14.4025 9.88958 14.3052 9.78315C14.2786 9.74767 12.8686 8.34368 12.8686 8.34368C12.78 8.25499 12.78 8.10421 12.8686 8.01552L13.4616 7.41242C14.0104 6.86253 14.8956 6.86253 15.4443 7.41242L16.595 8.56541C17.135 9.10643 17.135 9.99335 16.595 10.5432",
    fill: "#768696"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 23.5,
    width: 23,
    height: 23,
    rx: 4.5,
    transform: "rotate(-180 23.5 23.5)",
    stroke: "#313942"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.6ea25292ee5577c42f7422e9ca267d73.svg";
export { ForwardRef as ReactComponent };